import './index.scss'

import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import React, { Suspense } from 'react'

import './i18n'

// Suppress React error overlay for 401 (session expired). We clear auth in App/useCurrentUser;
// preventing default here stops the overlay so the user just sees login instead of an error.
window.addEventListener(
  'unhandledrejection',
  event => {
    if (event?.reason?.response?.status === 401) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  },
  true
)
import { initFacebookSdk } from './hooks/useFacebook'
import { ApiProvider } from './hooks/useApi'
import App from './App'
import reportWebVitals from './reportWebVitals'

const render = () => {
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(
    <BrowserRouter>
      <ApiProvider>
        <Suspense fallback={<div />}>
          <App />
        </Suspense>
      </ApiProvider>
    </BrowserRouter>,
  )
}

// wait for facebook sdk before startup
initFacebookSdk().then(render)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
